<template lang="pug">
  div.item-option
    div.name(@click="toggle(item)")
      span  {{item.name}}
      button.fa(:class="item.fold ? 'fa-plus': 'fa-minus'")

    template(v-if="item.type === 'checkbox' ")
      ul.checkbox(v-show="!item.fold")
        li(v-for="(v, i) in item.value")
          label(:for="`${item.name}_${v.value}`") {{v.value}}
          input(:name="item.name", :id="`${item.name}_${v.value}`", type="checkbox", :value="v.value")
    template(v-if="item.type === 'color'")
      ul.color(v-show="!item.fold")
        li(v-for="(v, i) in item.value")
          div.color-item(:style="`background:${v.value}`")

    template(v-if="item.type === 'list'")
      ul.list(v-show="!item.fold")
        li(v-for="(v, i) in item.value")
          p(@click="doSelectFilter(v.value)") {{v.value}}

    template(v-if="item.type === 'size'")
      ul.size(v-show="!item.fold")
        li(v-for="(v, i) in item.value")
          div.size-item
            span {{v.value}}
            i.fa.fa-check

</template>
<script>
export default {
  name: 'ItemOption',
  props: ['item', 'toggle', 'doSelectCategory', 'doSelectFilter']
}
</script>

<style lang="scss" scoped>
.item-option {
  padding: 0 1.25rem;
}
.color-item {
  border: 1px solid #ccc;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

ul.size,
ul.color {
  display: flex;
  flex-flow: row wrap;
}

.size-item {
  width: 2.5rem;
  height: 3rem;
  border: 1px solid #ccc;
  border-right: none;
  text-align: center;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
}

.size li:last-child .size-item {
    border-right: 1px solid #ccc;
}

.name {
  background: none;
  border-top: 1px solid #e7e7ef;
  margin: 0 0 .625rem;
  padding: 1.3em 0 .35em;
  text-transform: none;
  font-family: akzidenz-grotesk,Arial,sans-serif;
  font-weight: 500;
  font-size: 14px;
  font-size: .875rem;
  line-height: 32px;
  line-height: 2rem;
  color: #1a1a1a;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
</style>
